export const whiteList = [
    'nominatim',
    'create', 
    //'authenticate',
    'authenticateEntreprise',
    'getAllPays', 
    'resetPassword'
]